import { EducatorsTeamsMemberIndex } from "@/types/serializers"
import { useProps } from "@/lib/page-rendering"

export type IndexProps = {
  members: Array<EducatorsTeamsMemberIndex>
  team_name: string
}

export const useIndexProps = () => useProps<IndexProps>()
